import React from "react";
import { Link } from "react-router-dom";
import ConsultancyNavbar from "../ConsultancyNavbar";
import ConsultancyFooter from "../ConsultancyFooter";

const AboutPage = () => {
  return (
    <div className="consultancy-wrapper">
      <ConsultancyNavbar />

      {/* Header */}
      <section className="py-5 consultancy-section-dark text-center">
        <div className="container">
          <span className="consultancy-badge-gold mb-2">Our Mission & Platform</span>
          <h1 className="display-5 font-weight-bold consultancy-gold-title mb-3">Empowering Overseas Education Consultancies</h1>
          <p className="consultancy-lead-text mx-auto" style={{ maxWidth: "680px" }}>
            EdOps Global is the leading B2B operations software for study abroad agencies, regional franchises, and admission partners worldwide.
          </p>
        </div>
      </section>

      {/* Story & Vision */}
      <section className="py-5 container">
        <div className="row align-items-center g-4 g-lg-5">
          <div className="col-lg-6">
            <div className="h-100 d-flex align-items-center">
              <img
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=700&q=80"
                alt="EdOps Leadership Team"
                className="img-fluid rounded-4 shadow-lg w-100"
                style={{ border: "1px solid rgba(212, 175, 55, 0.25)", maxHeight: "420px", objectFit: "cover" }}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="d-flex flex-column justify-content-center h-100">
              <div>
                <span className="consultancy-badge-gold mb-2">Platform Vision</span>
                <h2 className="font-weight-bold consultancy-gold-title mb-3">Building Technology for Study Abroad Agencies</h2>
                <p className="text-muted" style={{ lineHeight: "1.8" }}>
                  Overseas education consultancies often struggle with fragmented manual spreadsheets, delayed SOP drafts, complex sub-agent commission splits, and non-transparent application tracking. EdOps Global unifies every department into a seamless dark-glass cloud operating portal.
                </p>
              </div>

              <div className="row g-3 mt-2">
                <div className="col-6">
                  <div className="consultancy-stat-card p-3 text-center">
                    <div className="consultancy-stat-number fs-2">500+</div>
                    <small className="text-muted font-weight-bold">Agency Partners</small>
                  </div>
                </div>
                <div className="col-6">
                  <div className="consultancy-stat-card p-3 text-center">
                    <div className="consultancy-stat-number fs-2">50,000+</div>
                    <small className="text-muted font-weight-bold">Applications Processed</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-5 consultancy-section-dark">
        <div className="container text-center">
          <span className="consultancy-badge-gold mb-2">Why Consultancies Choose Us</span>
          <h2 className="display-6 font-weight-bold consultancy-gold-title mb-5">Our Technology Pillars</h2>

          <div className="row g-4">
            {[
              { title: "Multi-Tenant Security", desc: "Enterprise-grade data isolation ensuring your consultancy's student leads, revenue splits, and university agreements remain completely private.", icon: "fa-shield-alt" },
              { title: "AI Application Acceleration", desc: "Reduce application drafting time from 5 days to 15 minutes using automated university profile matching and SOP generation.", icon: "fa-microchip" },
              { title: "Transparent Financial Engine", desc: "Real-time visibility into university commission balances, agent payouts, loan referral bonuses, and fee collections.", icon: "fa-coins" },
            ].map((p, idx) => (
              <div key={idx} className="col-md-4">
                <div className="consultancy-glass-card p-4 h-100">
                  <i className={`fas ${p.icon} text-warning fa-3x mb-3`}></i>
                  <h5 className="font-weight-bold consultancy-gold-title mb-2">{p.title}</h5>
                  <p className="text-muted small mb-0">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ConsultancyFooter />
    </div>
  );
};

export default AboutPage;
